import { motion } from "framer-motion";
import ElfsightWidget from "@/components/ElfsightWidget";

export default function ReviewsElfsight() {
    return (
        <section
            id="testimonials"
            className="relative py-28 lg:py-36 overflow-hidden"
            data-testid="testimonials-section"
        >
            <div
                className="absolute inset-0 pointer-events-none opacity-50"
                style={{
                    background:
                        "radial-gradient(ellipse 50% 50% at 50% 50%, rgba(200,165,90,0.08), transparent 70%)",
                }}
            />
            <div className="relative max-w-6xl mx-auto px-6 lg:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="text-center mb-14"
                >
                    <span className="block text-gold text-[11px] uppercase tracking-[0.32em] mb-5">
                        Отзиви
                    </span>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tightest">
                        Какво казват клиентите ни
                    </h2>
                    <p className="mt-5 text-ink-muted max-w-2xl mx-auto">
                        Реални отзиви от нашите клиенти в Google.
                    </p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="rounded-3xl overflow-hidden"
                    data-testid="elfsight-google-reviews"
                >
                    <ElfsightWidget appId="fc235a72-5fd2-44d4-8008-a47c3ccb60ae" />
                </motion.div>
            </div>
        </section>
    );
}
